import Skeleton from '@passkeys/ui/skeleton';

function TokenItemSkeleton() {
  return (
    <div className="flex w-full items-center gap-x-3 py-4">
      <Skeleton height={40} width={40} />

      <div className="flex flex-1 items-center justify-between gap-x-3">
        <div className="flex flex-col">
          <Skeleton height={14} width={100} />
          <Skeleton className="mt-1.5" height={14} width={48} />
        </div>

        <div className="flex flex-col items-end gap-y-1">
          <Skeleton shape="circle" height={20} width={60} />
          <Skeleton height={12} width={80} />
        </div>
      </div>

      <Skeleton height={24} width={24} shape="circle" />
    </div>
  );
}

function Loading() {
  return (
    <ul className="flex w-full flex-col divide-y divide-solid divide-black/6">
      <li>
        <TokenItemSkeleton />
      </li>
      <li>
        <TokenItemSkeleton />
      </li>
      <li>
        <TokenItemSkeleton />
      </li>
    </ul>
  );
}

export default Loading;
